/** Flat design: adjacent panels meet edge-to-edge with no gap. */
export const PANEL_GAP = 0

/** Flat design: outermost panels extend fully to the window edges. */
export const PANEL_EDGE_INSET = 0

/** Flat design: panel edges have square corners. */
export const RADIUS_EDGE = 0

/** Flat design: interior panel corners are square. */
export const RADIUS_INNER = 0

/** Minimum width for any content panel */
export const PANEL_MIN_WIDTH = 200

/** Minimum width for content panels — reduced on mobile to allow full-width rendering */
export function getResponsivePanelMinWidth(layoutMode: 'mobile' | 'tablet' | 'desktop'): number {
  switch (layoutMode) {
    case 'mobile': return 200
    case 'tablet': return 200
    case 'desktop': return 200
  }
}

/** Flat design: no vertical overflow is needed for panel shadows. */
export const PANEL_STACK_VERTICAL_OVERFLOW = 0

/**
 * Shared resize sash geometry.
 *
 * Keep all seams (sidebar, navigator/content, panel/panel) aligned by deriving
 * offsets from these constants instead of hardcoded pixel literals.
 */
export const PANEL_SASH_HIT_WIDTH = 8
export const PANEL_SASH_LINE_WIDTH = 2

/**
 * When the sash is inserted between two flex items, flex gap would apply twice
 * (item↔sash and sash↔item). Pull it back by half the gap on both sides so
 * the visible distance remains exactly PANEL_GAP.
 */
export const PANEL_SASH_FLEX_MARGIN = -(PANEL_GAP / 2)

/** Half-width helper for centering sash containers on seam coordinates. */
export const PANEL_SASH_HALF_HIT_WIDTH = PANEL_SASH_HIT_WIDTH / 2
